import {
  useToaster,
  UseToasterReturnedProps,
  Toaster,
} from '@twilio-paste/core/toast';
import { createContext, ReactElement } from 'react';

// Initialized with mock Toast props; will be replaced immediately on load
export const ToastContext = createContext<UseToasterReturnedProps>({
  toasts: [],
  pop: () => undefined,
  push: () => undefined,
});

export const ToastProvider = ({ children }): ReactElement => {
  const toaster = useToaster();

  return (
    <ToastContext.Provider value={toaster}>
      <Toaster {...toaster} />
      {children}
    </ToastContext.Provider>
  );
};
